import React from 'react';
import { useUIStore } from '../../stores';
import { Check, X, AlertCircle, Info } from 'lucide-react';

const icons = {
  success: Check,
  error: X,
  warning: AlertCircle,
  info: Info,
};

const styles = {
  success: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800',
  error: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800',
  warning: 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800',
  info: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800',
};

const iconStyles = {
  success: 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400',
  error: 'bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400',
  warning: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 dark:text-yellow-400',
  info: 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400',
};

export default function Toast({ id, type = 'info', title, message }) {
  const { removeToast } = useUIStore();
  const Icon = icons[type] || icons.info;
  
  return (
    <div className={`
      toast-enter min-w-80 max-w-md p-4 rounded-xl border shadow-lg
      ${styles[type]}
    `}>
      <div className="flex items-start gap-3">
        <div className={`p-1.5 rounded-lg flex-shrink-0 ${iconStyles[type]}`}>
          <Icon className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          {title && (
            <p className="font-medium text-gray-900 dark:text-white">{title}</p>
          )}
          {message && (
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-0.5">{message}</p>
          )}
        </div>
        <button
          onClick={() => removeToast(id)}
          className="p-1 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-gray-400 hover:text-gray-600 flex-shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
